import { CourseState, CourseStateList } from '../../_types';

export type SummaryResource = {
  id: string;
  displayName: string;
  description?: string;
  pictureUrl?: string;
  url?: string;
};

export type Course = {
  id: string;
  number: number;
  name: string;
  description: string;
  picture?: { url: string };
  state: CourseState;
  startDate?: Date;
  endDate?: Date;
  lecturers: SummaryResource[];
  studyDirectorId: string;
  modifiedDate?: Date;
  studyDirector?: SummaryResource;
};

export const initialCourse = {
  id: '',
  number: 0,
  name: '',
  description: '',
  state: 'ACTIVE' as CourseState,
  picture: {
    path: ''
  },
  lecturers: [],
  studyDirectorId: '',
};
